import { GETPICKERS } from "../utility/constants";
export default function (state = null, action) {
  switch (action.type) {
    case "INTRANSIT_JOBS":
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_intransit_job.js